import React, { useState, useRef } from "react";
import { Box, Typography, Grid, Card, FormControlLabel, Checkbox, Avatar } from "@mui/material";
import CustomTextField from "./custom/CustomTextField";
import CustomSelectField from "./custom/CustomSelectField";
import CustomDatePicker from "./custom/CustomDatePicker";
import CustomNumberField from "./custom/CustomNumberField";
import CustomButton from "./custom/CustomButton";
import CustomFooter from "./custom/CustomFooter";
import PhotoCropUploadModal from "./custom/PhotoCropUploadModal";
import Container from "@mui/material/Container";
import { MenuItem } from "@mui/material";
import {
  isBlank,
  isPasswordValid,
  doesPasswordsMatch,
  isEmailValid,
  isKtpValid,
  isNidnValid,
} from "../utils/ValidationRules";
import { showSuccessToast, showErrorToast } from "../utils/swalToast";
import "sweetalert2/dist/sweetalert2.css";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import CustomAutocompleteField from "./custom/CustomAutoCompleteField";

const Register = () => {
  const [role, setRole] = useState("");
  const [negaraAsal, setNegaraAsal] = useState(null);
  const [provinsiInstitusi, setProvinsiInstitusi] = useState(null);
  const [provinsiInstitusiName, setProvinsiInstitusiName] = useState("");
  const [kotaInstitusi, setKotaInstitusi] = useState(null);
  const [namaInstitusi, setNamaInstitusi] = useState(null);
  const [jenjangMengajar, setJenjangMengajar] = useState("");
  const [pendidikanTerakhir, setPendidikanTerakhir] = useState("");
  const [jenjangAkademik, setJenjangAkademik] = useState("");
  const [tanggalLahir, setTanggalLahir] = useState("");
  const [email, setEmail] = useState("");
  const [ktp, setKtp] = useState("");
  const [namaLengkap, setNamaLengkap] = useState("");
  const [gelarDepan, setGelarDepan] = useState("");
  const [gelarBelakang, setGelarBelakang] = useState("");
  const [tempatLahir, setTempatLahir] = useState("");
  const [programStudi, setProgramStudi] = useState("");
  const [bidangKeahlian1, setBidangKeahlian1] = useState("");
  const [bidangKeahlian2, setBidangKeahlian2] = useState("");
  const [bidangKeahlian3, setBidangKeahlian3] = useState("");

  const [nidn, setNidn] = useState("");
  const [isNoNIDNChecked, setIsNoNIDNChecked] = useState(false)
  
  const [nomorHandphone, setNomorHandphone] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  // Store Roles
  const [roleMenuItems, setRoleMenuItems] = useState([]);
  const [negaraAsalItems, setNegaraAsalItems] = useState([]);
  const [provinsiInstitusiItems, setProvinsiInstitusiItems] = useState([]);
  const [kotaInstitusiItems, setKotaInstitusiItems] = useState([]);
  const [namaInstitusiItems, setNamaInstitusiItems] = useState([]);
  const [jenjangMengajarItems, setJenjangMengajarItems] = useState([]);
  const [pendidikanTerakhirItems, setPendidikanTerakhirItems] = useState([]);
  const [jenjangAkademikItems, setJenjangAkademikItems] = useState([]);

  // Cropping only stages the photo locally (pendingPhotoBlob); it's bundled
  // into the register FormData on submit rather than uploaded separately.
  const [selectedImageSrc, setSelectedImageSrc] = useState(null);
  const [openCropModal, setOpenCropModal] = useState(false);
  const [pendingPhotoBlob, setPendingPhotoBlob] = useState(null);
  const [pendingPhotoPreviewUrl, setPendingPhotoPreviewUrl] = useState(null);
  const fileInputRef = useRef(null);

  const navigate = useNavigate();

  const linkStyle = {
    fontWeight: "bold",
    textDecoration: "none",
    color: "#003158",
    "&:hover": {
      color: "#00213A",
    },
  };

  // Each dropdown fetches its own options on first open instead of every
  // list being hit upfront on mount. `fetchOnce` skips the request if that
  // list is already loaded, so re-opening a dropdown doesn't re-fetch it.
  const fetchOnce = async (items, setItems, path) => {
    if (items.length > 0) return;
    try {
      const res = await axios.get(`${process.env.REACT_APP_BACKEND_HOST}${path}`);
      setItems(res.data.data);
    } catch (error) {
      console.error("Failed to fetch data:", error);
    }
  };

  const fetchRoles = () => fetchOnce(roleMenuItems, setRoleMenuItems, "/roles");
  const fetchNegaraAsalItems = () => fetchOnce(negaraAsalItems, setNegaraAsalItems, "/countries");
  const fetchJenjangMengajarItems = () =>
    fetchOnce(jenjangMengajarItems, setJenjangMengajarItems, "/teaching_levels");
  const fetchPendidikanTerakhirItems = () =>
    fetchOnce(pendidikanTerakhirItems, setPendidikanTerakhirItems, "/educations");
  const fetchJenjangAkademikItems = () =>
    fetchOnce(jenjangAkademikItems, setJenjangAkademikItems, "/academic_levels");

  // These three cascade off a parent selection, so they're also filtered
  // server-side instead of fetching (and client-filtering) the full table.
  const fetchProvinsiItems = () => {
    if (!negaraAsal) return;
    fetchOnce(provinsiInstitusiItems, setProvinsiInstitusiItems, `/provinces?country_code=${negaraAsal}`);
  };
  const fetchKotaItems = () => {
    if (!provinsiInstitusi) return;
    fetchOnce(kotaInstitusiItems, setKotaInstitusiItems, `/regencies?province_id=${provinsiInstitusi}`);
  };
  const fetchInstitusiItems = () => {
    if (!kotaInstitusi) return;
    fetchOnce(namaInstitusiItems, setNamaInstitusiItems, `/institutions?regency_name=${kotaInstitusi}`);
  };

  const registerUser = async (e) => {
    e.preventDefault();
    try {
      const formData = new FormData();
      formData.append("namaLengkap", namaLengkap);
      formData.append("gelarDepan", gelarDepan);
      formData.append("gelarBelakang", gelarBelakang);
      formData.append("tempatLahir", tempatLahir);
      formData.append("tanggalLahir", tanggalLahir);
      formData.append("namaInstitusi", namaInstitusi);
      formData.append("kotaInstitusi", kotaInstitusi);
      formData.append("provinsiInstitusi", provinsiInstitusiName);
      formData.append("negaraAsal", negaraAsal);
      formData.append("programStudi", programStudi);
      formData.append("jenjangMengajar", jenjangMengajar);
      formData.append("pendidikanTerakhir", pendidikanTerakhir);
      formData.append("jenjangAkademik", jenjangAkademik);
      formData.append("bidangKeahlian1", bidangKeahlian1);
      formData.append("bidangKeahlian2", bidangKeahlian2);
      formData.append("bidangKeahlian3", bidangKeahlian3);
      formData.append("nidn", nidn);
      formData.append("hasNidn", !isNoNIDNChecked);
      formData.append("ktp", ktp);
      formData.append("nomorHandphone", nomorHandphone);
      formData.append("email", email);
      formData.append("password", password);
      formData.append("confirmPassword", confirmPassword);
      formData.append("role", role);
      formData.append("isKtpUpdated", 1);
      if (pendingPhotoBlob) {
        formData.append("foto", pendingPhotoBlob, "profile.jpg");
      }

      await axios.post(
        `${process.env.REACT_APP_BACKEND_HOST}/users`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );

      showSuccessToast("Registrasi Berhasil!").then(() => {
        navigate("/");
      });
    } catch (err) {
      if (err.response) {
        showErrorToast(err.response.data.msg);
      }
    }
  };

  const resetForm = () => {
    setNamaLengkap("");
    setGelarDepan("");
    setGelarBelakang("");
    setTempatLahir("");
    setTanggalLahir("");
    setNegaraAsal("");
    setProvinsiInstitusi("");
    setKotaInstitusi("");
    setNamaInstitusi("");
    setProvinsiInstitusiItems([]);
    setKotaInstitusiItems([]);
    setNamaInstitusiItems([]);
    setProgramStudi("");
    setJenjangMengajar("");
    setPendidikanTerakhir("");
    setJenjangAkademik("");
    setBidangKeahlian1("");
    setBidangKeahlian2("");
    setBidangKeahlian3("");
    setNidn("");
    setKtp("");
    setNomorHandphone("");
    setEmail("");
    setPassword("");
    setConfirmPassword("");
    setRole("");
    setPendingPhotoBlob(null);
    setPendingPhotoPreviewUrl(null);
  };

  const handlePhotoFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedImageSrc(URL.createObjectURL(file));
      setOpenCropModal(true);
    }
    event.target.value = "";
  };

  const handleUploadPhotoClick = () => {
    fileInputRef.current.click();
  };

  return (
    <div
      style={{
        backgroundColor: "#f0ebeb",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Container maxWidth="lg">
        <Card
          variant="outlined"
          sx={{
            padding: "15px",
            marginTop: { xs: "40px", sm: "64px" },
            marginBottom: { xs: "40px", sm: "64px" },
            marginLeft: "10px",
            marginRight: "10px",
            borderRadius: 5,
          }}
        >
          <Box
            sx={{
              margin: "15px",
            }}
          >
            <Typography
              variant="h4"
              sx={{
                textTransform: "uppercase",
                marginBottom: "20px",
              }}
            >
              Registrasi Anggota
            </Typography>
            <Grid container spacing={2}>
              <Grid item md={6} xs={12}>
                <Typography>
                  Role<span style={{ color: "red" }}>*</span>
                </Typography>
                <CustomSelectField
                  value={role}
                  rule={(value) => isBlank(value, "Role")}
                  onOpen={fetchRoles}
                  onChange={(event) => {
                    const newRole = event.target.value;
                    setRole(newRole);
                    if (newRole !== "Dosen") {
                      setNidn("");
                    }
                  }}
                  menuItems={roleMenuItems.map((role, index) => (
                    <MenuItem key={index} value={role.name}>
                      {role.name}
                    </MenuItem>
                  ))}
                />
              </Grid>
              <Grid item md={6} xs={12}>
                <Typography>
                  KTP<span style={{ color: "red" }}>*</span>
                </Typography>
                <CustomNumberField
                  value={ktp}
                  rule={isKtpValid}
                  onChange={(event) => setKtp(event.target.value)}
                  maxInputLength={16}
                />
              </Grid>
              <Grid item md={12} xs={12}>
                <Typography>
                  Nama Lengkap<span style={{ color: "red" }}>*</span>
                </Typography>
                <CustomTextField
                  value={namaLengkap}
                  rule={(value) => isBlank(value, "Nama Lengkap")}
                  onChange={(event) => setNamaLengkap(event.target.value)}
                />
              </Grid>
              <Grid item md={6} xs={12}>
                <Typography> Gelar Depan</Typography>
                <CustomTextField
                  value={gelarDepan}
                  onChange={(event) => setGelarDepan(event.target.value)}
                />
              </Grid>
              <Grid item md={6} xs={12}>
                <Typography> Gelar Belakang</Typography>
                <CustomTextField
                  value={gelarBelakang}
                  onChange={(event) => setGelarBelakang(event.target.value)}
                />
              </Grid>
              <Grid item md={6} xs={12}>
                <Typography>
                  Tempat Lahir<span style={{ color: "red" }}>*</span>
                </Typography>
                <CustomTextField
                  value={tempatLahir}
                  rule={(value) => isBlank(value, "Tempat Lahir")}
                  onChange={(event) => setTempatLahir(event.target.value)}
                />
              </Grid>
              <Grid item md={6} xs={12}>
                <Typography>
                  Tanggal Lahir<span style={{ color: "red" }}>*</span>
                </Typography>
                <CustomDatePicker
                  value={tanggalLahir}
                  onChange={(event) => setTanggalLahir(event)}
                  format={"DD/MM/YYYY"}
                />
              </Grid>
              <Grid item md={12} xs={12}>
                <Typography>Negara Asal</Typography>
                <CustomAutocompleteField
                  value={negaraAsal}
                  onChange={(newValue) => {
                    setNegaraAsal(newValue ? newValue.code : "");
                    setProvinsiInstitusi("");
                    setKotaInstitusi("");
                    setNamaInstitusi("");
                    setProvinsiInstitusiItems([]);
                    setKotaInstitusiItems([]);
                    setNamaInstitusiItems([]);
                  }}
                  options={negaraAsalItems}
                  onOpen={fetchNegaraAsalItems}
                  placeholder="Pilih Negara Asal"
                  searchBy="code"
                />
              </Grid>
              <Grid item md={12} xs={12}>
                <Typography>Provinsi Institusi</Typography>
                <CustomAutocompleteField
                  value={provinsiInstitusi}
                  onChange={(newValue) => {
                    setProvinsiInstitusi(newValue ? newValue.id : "");
                    setProvinsiInstitusiName(newValue?.name || "");
                    setKotaInstitusi("");
                    setNamaInstitusi("");
                    setKotaInstitusiItems([]);
                    setNamaInstitusiItems([]);
                  }}
                  disabled={negaraAsal === null || negaraAsal === ""}
                  options={provinsiInstitusiItems}
                  onOpen={fetchProvinsiItems}
                  placeholder="Pilih Provinsi Institusi"
                  searchBy="id"
                />
              </Grid>
              <Grid item md={12} xs={12}>
                <Typography>Kota Institusi</Typography>
                <CustomAutocompleteField
                  value={kotaInstitusi}
                  onChange={(newValue) => {
                    setKotaInstitusi(newValue ? newValue.name : "");
                    setNamaInstitusi("");
                    setNamaInstitusiItems([]);
                  }}
                  disabled={
                    provinsiInstitusi === "" || provinsiInstitusi === null
                  }
                  options={kotaInstitusiItems}
                  onOpen={fetchKotaItems}
                  placeholder="Pilih Kota Institusi"
                  searchBy="name"
                />
              </Grid>
              <Grid item md={12} xs={12}>
                <Typography>Nama Institusi</Typography>
                <CustomAutocompleteField
                  value={namaInstitusi}
                  onChange={(newValue) => {
                    setNamaInstitusi(newValue ? newValue.name : "");
                  }}
                  disabled={kotaInstitusi === "" || kotaInstitusi === null}
                  options={namaInstitusiItems}
                  onOpen={fetchInstitusiItems}
                  placeholder="Pilih Institusi"
                  searchBy="name"
                />
              </Grid>
              <Grid item md={12} xs={12}>
                <Typography>
                  Program Studi<span style={{ color: "red" }}>*</span>
                </Typography>
                <CustomTextField
                  value={programStudi}
                  rule={(value) => isBlank(value, "Program Studi")}
                  onChange={(event) => setProgramStudi(event.target.value)}
                />
              </Grid>
              <Grid item md={4} xs={12}>
                <Typography>
                  Jenjang Mengajar<span style={{ color: "red" }}>*</span>
                </Typography>
                <CustomSelectField
                  value={jenjangMengajar}
                  onChange={(event) => setJenjangMengajar(event.target.value)}
                  onOpen={fetchJenjangMengajarItems}
                  menuItems={jenjangMengajarItems.map((level, index) => (
                    <MenuItem key={index} value={level.name}>
                      {level.name}
                    </MenuItem>
                  ))}
                />
              </Grid>
              <Grid item md={4} xs={12}>
                <Typography>
                  Pendidikan Terakhir <span style={{ color: "red" }}>*</span>
                </Typography>
                <CustomSelectField
                  value={pendidikanTerakhir}
                  onChange={(event) =>
                    setPendidikanTerakhir(event.target.value)
                  }
                  onOpen={fetchPendidikanTerakhirItems}
                  menuItems={pendidikanTerakhirItems.map(
                    (lastEducation, index) => (
                      <MenuItem key={index} value={lastEducation.name}>
                        {lastEducation.name}
                      </MenuItem>
                    )
                  )}
                />
              </Grid>
              <Grid item md={4} xs={12}>
                <Typography>
                  Jenjang Akademik<span style={{ color: "red" }}>*</span>
                </Typography>
                <CustomSelectField
                  value={jenjangAkademik}
                  onChange={(event) => setJenjangAkademik(event.target.value)}
                  onOpen={fetchJenjangAkademikItems}
                  menuItems={jenjangAkademikItems.map(
                    (academicLevel, index) => (
                      <MenuItem key={index} value={academicLevel.name}>
                        {academicLevel.name}
                      </MenuItem>
                    )
                  )}
                />
              </Grid>
              <Grid item md={4} xs={12}>
                <Typography>Bidang Keahlian 1</Typography>
                <CustomTextField
                  value={bidangKeahlian1}
                  onChange={(event) => setBidangKeahlian1(event.target.value)}
                />
              </Grid>
              <Grid item md={4} xs={12}>
                <Typography>Bidang Keahlian 2</Typography>
                <CustomTextField
                  value={bidangKeahlian2}
                  onChange={(event) => setBidangKeahlian2(event.target.value)}
                />
              </Grid>
              <Grid item md={4} xs={12}>
                <Typography>Bidang Keahlian 3</Typography>
                <CustomTextField
                  value={bidangKeahlian3}
                  onChange={(event) => setBidangKeahlian3(event.target.value)}
                />
              </Grid>
              <Grid item md={12} xs={12}>
                <Typography>
                  NIDN<span style={{ color: "red" }}>*</span>
                </Typography>
                <CustomNumberField
                  value={nidn}
                  onChange={(event) => setNidn(event.target.value)}
                  disabled={role !== "Dosen" || isNoNIDNChecked}
                  rule={() => isNidnValid(role, nidn)}
                  maxInputLength={10}
                />
                {/* Checkbox tambahan */}
                <FormControlLabel
                  control={
                    <Checkbox
                      disabled={role !== "Dosen"}
                      checked={isNoNIDNChecked}
                      onChange={(e) => setIsNoNIDNChecked(e.target.checked)}
                    />
                  }
                  label="Saya belum memiliki NIDN"
                />
              </Grid>
              <Grid item md={12} xs={12}>
                <Typography>
                  Nomor Handphone<span style={{ color: "red" }}>*</span>
                </Typography>
                <CustomNumberField
                  value={nomorHandphone}
                  rule={(value) => isBlank(value, "Nomor Handphone")}
                  onChange={(event) => setNomorHandphone(event.target.value)}
                  maxInputLength={16}
                />
              </Grid>
              <Grid item md={12} xs={12}>
                <Typography>
                  Alamat Email<span style={{ color: "red" }}>*</span>
                </Typography>
                <CustomTextField
                  type="email"
                  value={email}
                  rule={isEmailValid}
                  onChange={(event) => setEmail(event.target.value)}
                />
              </Grid>
              <Grid item md={6} xs={12}>
                <Typography>
                  Password<span style={{ color: "red" }}>*</span>
                </Typography>
                <CustomTextField
                  type="password"
                  value={password}
                  rule={isPasswordValid}
                  onChange={(event) => setPassword(event.target.value)}
                />
              </Grid>
              <Grid item md={6} xs={12}>
                <Typography>
                  Confirm Password<span style={{ color: "red" }}>*</span>
                </Typography>
                <CustomTextField
                  type="password"
                  value={confirmPassword}
                  rule={(value) => doesPasswordsMatch(password, value)}
                  onChange={(event) => setConfirmPassword(event.target.value)}
                />
              </Grid>
              <Grid item xs={12}>
                <Typography>Upload Foto</Typography>
                <Box sx={{ display: "flex", alignItems: "center", gap: 2, marginTop: "8px" }}>
                  <Avatar src={pendingPhotoPreviewUrl} sx={{ width: 72, height: 72 }} />
                  <CustomButton
                    text="Upload Foto"
                    baseColor="#003158"
                    hoverColor="#00213A"
                    isFullWidth={false}
                    onClick={handleUploadPhotoClick}
                  />
                  <input
                    type="file"
                    accept="image/png, image/jpeg, image/jpg"
                    ref={fileInputRef}
                    style={{ display: "none" }}
                    onChange={handlePhotoFileChange}
                  />
                </Box>
              </Grid>
              <Grid item md={6} xs={12}>
                <CustomButton
                  text="Confirm"
                  baseColor="#003158"
                  hoverColor="#00213A"
                  onClick={registerUser}
                />
              </Grid>
              <Grid item md={6} xs={12}>
                <CustomButton
                  text="Reset"
                  baseColor="#A92027"
                  hoverColor="#8C1016"
                  onClick={resetForm}
                />
              </Grid>
            </Grid>
            <Grid
              style={{
                marginTop: "10px",
              }}
            >
              <Link to="/" style={linkStyle}>
                kembali ke halaman login
              </Link>
            </Grid>
          </Box>
        </Card>
      </Container>
      <Grid item md={12} xs={12}>
        <CustomFooter
          marginTop={0}
          text="IKDKI © 2026 by Ikatan Dosen Katholik Indonesia"
        />
      </Grid>

      <PhotoCropUploadModal
        open={openCropModal}
        onClose={() => setOpenCropModal(false)}
        imageSrc={selectedImageSrc}
        onCropped={(blob) => {
          setPendingPhotoBlob(blob);
          setPendingPhotoPreviewUrl(URL.createObjectURL(blob));
        }}
      />
    </div>
  );
};

export default Register;
